// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__27YLj","item":"styles_item__3CCZt","selected":"styles_selected__2Xu90","sectionTitle":"styles_sectionTitle__31e6E","addItem":"styles_addItem__G_2Y8"};